module.exports = __webpack_public_path__ + "static/media/montly_prize4.f16e67ff.svg";